import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';

// 完整引入 Element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueI18n from 'vue-i18n'

// 引入自定义的语言包
import hk from './lang/hk'
import en from './lang/en'

import RouterLinkLang from './components/RouterLinkLang.vue';
Vue.component('RouterLinkLang', RouterLinkLang);

// 使用 VueI18n
Vue.use(VueI18n)

// 配置 ElementUI 使用国际化
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// 设置多语言配置
const messages = {
  en: { ...en },
  hk: { ...hk }
}

function getLanguage() {
  const urlParams = new URLSearchParams(window.location.search);
  let lang = urlParams.get('lang');

  if (lang) lang = lang.toLowerCase();

  if (lang === 'en') return 'en';
  if (lang === 'zh' || lang === 'zh-cn' || lang === 'cn') return 'hk';
  if (lang === 'hk') return 'hk';

  const browserLang = (navigator.language || navigator.userLanguage).toLowerCase();
  if (browserLang.includes('en')) return 'en';
  return 'hk';
}

// 实例化 i18n
const i18n = new VueI18n({
  locale: getLanguage(),
  messages
});


Vue.use(ElementUI, { locale })

Vue.config.productionTip = false;

// 创建 Vue 实例
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
